"use client";

import { createContext, useState, ReactNode, useContext, useEffect } from "react";
import { IntlProvider } from "react-intl";
import en from "@/locales/en.json";
import ru from "@/locales/ru.json";
import { AppConstants } from '@/app/constants';

const messages = { en, ru };
type Locale = "en" | "ru";

interface LocaleContextProps {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

const LocaleContext = createContext<LocaleContextProps | null>(null);

export const LocaleProvider = ({ children }: { children: ReactNode }) => {
  const [locale, setLocale] = useState<Locale>("en");

  useEffect(() => {
    const lcl = localStorage.getItem(AppConstants.Locale);
    if (lcl == "en" || lcl == "ru") setLocale(lcl ?? "en");
  }, []);

  useEffect(() => {
    localStorage.setItem(AppConstants.Locale, locale);
  }, [locale]);

  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
      <IntlProvider locale={locale} messages={messages[locale]}>
        {children}
      </IntlProvider>
    </LocaleContext.Provider>
  );
};

export const useLocale = () => {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error("useLocale must be used within a LocaleProvider");
  }
  return context;
};
